
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`The Question`}</h2>
    <h4>{`Think about how much time you waste daily on loads of small pieces of irrelevant fluff hiding the few big, relevant bits of information you need?`}</h4>
    <h2>{`The Promise`}</h2>
    <h4>{`We want to help you to extract more value from audio and video content, by giving you the tools to find out for yourself what’s worth your time - so that you, and your clients can #skiptothegoodbit​`}</h4>
    <h2>{`The Ask`}</h2>
    <h4>{`Right now we are looking to speak with researchers, reviewers and content curators, to show you the tools we've built to make content more relevant, personalised, and ultimately more valuable to all consumers across the world who want to #skipthingsdone`}</h4>
    <h2>{`The Pledge`}</h2>
    <h4>{`At S-K-I-P we are on a mission of freeing people from relying on unpredictable, ever changing algorithms and recommendations. We envision true platform independence, with community at its core.`}</h4>
    <h2>{`The Manifesto`}</h2>
    <h4>{`"We are followers, but we will not blindly follow."`}</h4>
    <p>{`Signed, Lukasz, Founder of S-K-I-P`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;